export default "__VITE_ASSET__ef2c9e5d__"